export const PARAM_HEADER_TITLE = 'headerTitle'
export const PARAM_IS_WEB_VIEW = 'isWebView'
export const PARAM_IS_EMBEDDED_VIEW = 'isEmbeddedView'
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp'
export const PARAM_APIKEY = 'apikey' // apikey cố định mặc định cho app chứ ko phải để chuyển link
export const PARAM_PAYMENT_METHOD = 'paymentMethod' // phương thức thanh toán cố định mặc định 1 thanh toán

export const PARAM_REFER_USER_ID = 'referUserId' // id người giới thiệu
export const PARAM_REFER_STATION_ID = 'referStationId' // id trạm giới thiệu

export const MESSAGE_BACK_TO_HOME_MINI_APP = 'BackToHomeMiniApp'
